import {HubProxy, HubProxyFactory} from '../../modules/HubProxyModule';
import {ConfigService} from '../../modules/ConfigModule';

import {ngStorage} from 'ngstorage';
import {MenuService} from "../../modules/MenuModule";
import {DataHubService} from "../../modules/DataHubModule";
import {popWindow} from "../../directive/Popout";
import {UserDto} from "../../model/UserDto";

export default class HomeController {
    static $inject = ['$dataHub', '$config', '$menu', '$state', '$http', '$sessionStorage', '$window'];
    hub: HubProxy;
    userInfo: UserDto;
    serverVersion: string;
    clientVersion: string;
    private qbPending: number;

    constructor(private $dataHub: DataHubService,
                private $config: ConfigService,
                private $menu: MenuService,
                private $state,
                private $http: ng.IHttpService,
                private $sessionStorage: ngStorage.StorageService,
                private $window: ng.IWindowService) {

        this.clientVersion = $window.version;
        $dataHub.onServerVersion(v => this.serverVersion = v);
        $dataHub.onQbPendingChanged(val => {
            console.debug('pending', val);
            this.qbPending = val;
        });

        $config.checklogin().then(r => this.userInfo = r);

        $dataHub.onConnected(this.refresh);
    }

    logout = () => this.$config.logout();

    refresh = () => {
        this.$dataHub.qbPendingSubscribe(null);
    }

    customerSelected = (customer) => {
        console.debug('selected', customer);
        var url = this.$state.href('customer.view', {customerGuid: customer.guid});
        popWindow(url, customer.guid);
    };

}
